import { failSelectionlists } from './actions';
import { selectionlistConfig } from '../../config';
import { collapseGroups } from '../grouping/actions';
import * as types from './types';
import * as consts from '../constants';
import { AppDispatch, GetAppState } from '../index';
import { GroupingState } from '../grouping/state';
import { invalidateSelectionListProducts } from '../../shop/selectionlists/api/useSelectionListProducts';
import { invalidateSelectionListSummary } from '../../api/selection-list/useSelectionListSummary';
import { invalidateSelectionListGroupedItems } from '../../api/selection-list/useSelectionListGroupedItems';
import { disableListLoading, enableListLoading } from '../listLoading/actions';
import { invalidateSelectionListAggregations } from '../../shop/selectionlists/useSelectionListAggregations';
import { http } from '../../api/axios';

const config = selectionlistConfig();

export const deleteSelectionlistGroupedItem = (group: GroupingState) =>
    changeAmountGroupedItem(group, null, consts.ACTION_REMOVE);

export function changeAmountGroupedItem(group: GroupingState, amount: number | null, command: string) {
    return (dispatch: AppDispatch, state: GetAppState) => {
        dispatch({
            type: types.SELECTIONLIST_GROUPED_CHANGE_REQUEST,
            payload: [group.key, group.id, command, amount].join(' ')
        });
        dispatch(enableListLoading());

        const listId = state().orderlist.id ?? '';

        const pathParams = {
            listId,
            source: consts.SOURCE_QUANTITY,
            kind: 'filter',
            action: command
        };

        const body = {};
        if (group.key === consts.GROUPBY_BUNDLES) {
            body['bundleRef'] = group.id;
        } else if (group.key === consts.GROUPBY_LISTS) {
            body['selectionListRef'] = group.id;
        }
        if (amount) {
            body['amount'] = amount;
        }

        http.put(config.endpointBulk, body, { pathParams })
            .then(() => {
                dispatch({ type: types.SELECTIONLIST_GROUPED_CHANGE_SUCCESS });
                invalidateSelectionListGroupedItems(listId).then();
                dispatch(collapseGroups());
                invalidateSelectionListSummary(listId).then();
                invalidateSelectionListProducts(listId).then();
                invalidateSelectionListAggregations(listId).then();
            })
            .catch(error => {
                dispatch({ type: types.SELECTIONLIST_GROUPED_CHANGE_FAILURE });
                dispatch(failSelectionlists(error, consts.SOURCE_SELECTIONLIST));
                invalidateSelectionListGroupedItems(listId).then();
            })
            .finally(() => {
                dispatch(disableListLoading());
            });
    };
}
